var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"width":"450","content-class":"modal modal-round"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',{staticClass:"close",on:{"click":function($event){_vm.show = false}}},[_vm._v("×")]),_c('v-card',[_c('app-released-ips-body',{on:{"close":function($event){_vm.show = false}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }